import { useLocation } from 'router-v6'
import { AGENT_BUILDER_BASE_PATH, FLOW_BUILDER_BASE_PATH } from './utils/agent-builder-route'

export interface FlowSectionConfig {
  title: string
  subtitle: string
  noun: string
  buildLabel: string
  builderBase: string
  runsBase: string
  listPath: string
  goToLabel: string
  allowsAi: boolean
}

export const FLOW_SECTIONS: Record<'agents' | 'flow', FlowSectionConfig> = {
  agents: {
    title: 'Agents',
    subtitle: 'Manage agents for your organization',
    noun: 'Agent',
    buildLabel: 'Agent Flow',
    builderBase: AGENT_BUILDER_BASE_PATH,
    runsBase: '/agent-runs',
    listPath: '/agents',
    goToLabel: 'Go to Agent flow',
    allowsAi: true,
  },
  flow: {
    title: 'Flow',
    subtitle: 'Build and manage call flows for your telephony applications.',
    noun: 'Flow',
    buildLabel: 'Flow',
    builderBase: FLOW_BUILDER_BASE_PATH,
    runsBase: '/flow/runs',
    listPath: '/flow',
    goToLabel: 'Go to Flow',
    allowsAi: false,
  },
}

/** Telephony > Flow is every page under /flow; any other page is Agents. */
export const sectionAt = (pathname: string) =>
  pathname === '/flow' || pathname.startsWith('/flow/') ? FLOW_SECTIONS.flow : FLOW_SECTIONS.agents

export const useFlowSection = () => sectionAt(useLocation().pathname)
